import { FunctionComponent, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

const Container = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  overflow: 'hidden',
  minWidth: 0,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const MainContainer: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  return (
    <Container>
      <Toolbar sx={{ displayPrint: 'none' }} />
      {children}
    </Container>
  );
};
